import type { ISerialize } from '@/objects/ISerialize';
import { formatDateIso } from '@/utilities/dateutils';

export class DeviceGpioRead implements ISerialize {
    public Port: number;

    public Time: Date;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { Port?: number; Time?: Date }) {
        this.Port = values.Port ?? 0;

        this.Time = values.Time ?? new Date('1970-01-01T00:00:00.000');
    }

    public serialize(): string {
        return '{' + `"Port": ${JSON.stringify(this.Port)}` + ',' + `"Time": ${'"' + formatDateIso(this.Time) + '"'}` + '}';
    }

    /**
     * Creates an instance of DeviceGpioRead from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { Port?: number; Time?: Date }): DeviceGpioRead {
        return new DeviceGpioRead(values);
    }

    public static _FromServerJson(json: any): DeviceGpioRead {
        return new DeviceGpioRead({ Port: json.Port, Time: json.Time instanceof Date ? json.Time : new Date(json.Time) });
    }

    /**
     * Creates an instance of DeviceGpioRead from another instance of DeviceGpioRead.
     * @param other The DeviceGpioRead you want to clone
     * @returns A cloned DeviceGpioRead
     */
    public static FromOther(other: DeviceGpioRead): DeviceGpioRead {
        return DeviceGpioRead._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return DeviceGpioRead.FromOther(this);
    }

    static NAME_OF_CLASS = 'DeviceGpioRead';
}
